// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock7-space1-bpIYc {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock7-space2-mQuZc {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock7-space3-aXZmM {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock7-space4-REmd1 {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock7-space5-fYuGo {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock7-space6-HfLDQ {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock7-space7-tld85 {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock7-space8-brYHB {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock7-spaceTop1-u5mjt {
	margin-top: 6px !important;
}

.WhyHostFormBlock7-spaceTop2-oz9_C {
	margin-top: 12px !important;
}

.WhyHostFormBlock7-spaceTop3-WFdH7 {
	margin-top: 18px !important;
}

.WhyHostFormBlock7-spaceTop4-qvlxQ {
	margin-top: 24px !important;
}

.WhyHostFormBlock7-spaceTop5-QE5S4 {
	margin-top: 30px !important;
}

.WhyHostFormBlock7-spaceTop6-NmoQE {
	margin-top: 36px !important;
}

.WhyHostFormBlock7-spaceTop7-cAVTz {
	margin-top: 42px !important;
}

.WhyHostFormBlock7-spaceTop8-b8yUr {
	margin-top: 48px !important;
}

.WhyHostFormBlock7-noMargin-RIHas {
	margin: 0px !important;
}

.WhyHostFormBlock7-padding1-N4L1W {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock7-padding2-TICws {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock7-padding3-izEYE {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock7-padding4-e26n5 {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock7-padding5-buck8 {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock7-padding6-H5t8n {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock7-padding7-j6t11 {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock7-paddingTop1-lpx1B {
	padding-top: 6px !important;
}

.WhyHostFormBlock7-paddingTop2-pH_f2 {
	padding-top: 12px !important;
}

.WhyHostFormBlock7-paddingTop3-BO7zn {
	padding-top: 18px !important;
}

.WhyHostFormBlock7-paddingTop4-EZLev {
	padding-top: 24px !important;
}

.WhyHostFormBlock7-paddingTop5-d9eok {
	padding-top: 30px !important;
}

.WhyHostFormBlock7-paddingTop6-vLkcL {
	padding-top: 36px !important;
}

.WhyHostFormBlock7-paddingTop7-O80w_ {
	padding-top: 42px !important;
}

.WhyHostFormBlock7-noPadding-Fu1fL {
	padding: 0px !important;
}

.WhyHostFormBlock7-spaceMarginBottom0-P1xJy {
	margin-bottom: 0;
}

.WhyHostFormBlock7-textBold-pEwzF {
	font-weight: 500 !important;
}

.WhyHostFormBlock7-textBolder-lyB_6 {
	font-weight: 700 !important;
}

.WhyHostFormBlock7-textNormal-GHdqu {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostFormBlock7-textDarkBlue-Ysm_i {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock7-textLightBlue-b27K4 {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock7-textLightSandleGreen-OKgaX {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock7-textLightBrown-dEloa {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock7-textMediumMaroon-wvCH1 {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock7-textBrown-mU44d {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock7-textMaroon-ov8zD {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock7-textDarkBrown-cWWN6 {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock7-textMediumBrown-YbvH3 {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock7-textSkyBlue-KdFvr {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock7-textGray-thhvE {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock7-errorMessage-Gybql {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostFormBlock7-userText-RO1k4 {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostFormBlock7-panelHeader-lHWZh {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostFormBlock7-exportSection-CRTR_ {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostFormBlock7-exportSectionGridSub-a59hj {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock7-exportText-TVkIq {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostFormBlock7-exportLinkImg-nQXfE {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostFormBlock7-exportImg-EvERP {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock7-linkBtn-xGV9e {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostFormBlock7-table-MSBNB {
	display: table;
}

.WhyHostFormBlock7-tableRow-P5VBp {
	display: table-row;
}

.WhyHostFormBlock7-tableCell-0ajZO {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock7-formGroup-HK3LU {
	margin-bottom: 6px;
}

.WhyHostFormBlock7-marginTop0-nFSao {
	margin-top: 0;
}

.WhyHostFormBlock7-marginBottom20-pRyvD {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock7-bannerImageBg-QW1J0 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostFormBlock7-bannerDelete-NOImL {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock7-exportLink-Q7opX {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock7-seachContent-A1idG {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostFormBlock7-marginBottom9-oFoVw {
	margin-bottom: 9px;
}

.WhyHostFormBlock7-spaceTop52-QRhi_ {
	margin-top: 52px;
}

.WhyHostFormBlock7-profileViewInner-eaRrk {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostFormBlock7-profileViewMain-SV0Lt {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostFormBlock7-profileViewlabel-JseZW {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostFormBlock7-profileViewMainContent-wCb2A {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostFormBlock7-reviewsFormStar-nmVx0 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostFormBlock7-reviewsFormStar-nmVx0 svg {
	cursor: pointer;
}

.WhyHostFormBlock7-addLanguageText-TZSXn {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostFormBlock7-exportSection-CRTR_ {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock7-spaceTop52-QRhi_ {
		margin-top: 18px;
	}

	.WhyHostFormBlock7-exportText-TVkIq {
		float: none;
		margin-top: 12px;
	}

	.WhyHostFormBlock7-exportSectionGridSub-a59hj {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostFormBlock7-profileViewlabel-JseZW {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock7-profileViewMainContent-wCb2A {
		width: 100%;
		text-align: center;
	}

	.WhyHostFormBlock7-panelHeader-lHWZh {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostFormBlock7-space1-bpIYc`,
	"space2": `WhyHostFormBlock7-space2-mQuZc`,
	"space3": `WhyHostFormBlock7-space3-aXZmM`,
	"space4": `WhyHostFormBlock7-space4-REmd1`,
	"space5": `WhyHostFormBlock7-space5-fYuGo`,
	"space6": `WhyHostFormBlock7-space6-HfLDQ`,
	"space7": `WhyHostFormBlock7-space7-tld85`,
	"space8": `WhyHostFormBlock7-space8-brYHB`,
	"spaceTop1": `WhyHostFormBlock7-spaceTop1-u5mjt`,
	"spaceTop2": `WhyHostFormBlock7-spaceTop2-oz9_C`,
	"spaceTop3": `WhyHostFormBlock7-spaceTop3-WFdH7`,
	"spaceTop4": `WhyHostFormBlock7-spaceTop4-qvlxQ`,
	"spaceTop5": `WhyHostFormBlock7-spaceTop5-QE5S4`,
	"spaceTop6": `WhyHostFormBlock7-spaceTop6-NmoQE`,
	"spaceTop7": `WhyHostFormBlock7-spaceTop7-cAVTz`,
	"spaceTop8": `WhyHostFormBlock7-spaceTop8-b8yUr`,
	"noMargin": `WhyHostFormBlock7-noMargin-RIHas`,
	"padding1": `WhyHostFormBlock7-padding1-N4L1W`,
	"padding2": `WhyHostFormBlock7-padding2-TICws`,
	"padding3": `WhyHostFormBlock7-padding3-izEYE`,
	"padding4": `WhyHostFormBlock7-padding4-e26n5`,
	"padding5": `WhyHostFormBlock7-padding5-buck8`,
	"padding6": `WhyHostFormBlock7-padding6-H5t8n`,
	"padding7": `WhyHostFormBlock7-padding7-j6t11`,
	"paddingTop1": `WhyHostFormBlock7-paddingTop1-lpx1B`,
	"paddingTop2": `WhyHostFormBlock7-paddingTop2-pH_f2`,
	"paddingTop3": `WhyHostFormBlock7-paddingTop3-BO7zn`,
	"paddingTop4": `WhyHostFormBlock7-paddingTop4-EZLev`,
	"paddingTop5": `WhyHostFormBlock7-paddingTop5-d9eok`,
	"paddingTop6": `WhyHostFormBlock7-paddingTop6-vLkcL`,
	"paddingTop7": `WhyHostFormBlock7-paddingTop7-O80w_`,
	"noPadding": `WhyHostFormBlock7-noPadding-Fu1fL`,
	"spaceMarginBottom0": `WhyHostFormBlock7-spaceMarginBottom0-P1xJy`,
	"textBold": `WhyHostFormBlock7-textBold-pEwzF`,
	"textBolder": `WhyHostFormBlock7-textBolder-lyB_6`,
	"textNormal": `WhyHostFormBlock7-textNormal-GHdqu`,
	"textDarkBlue": `WhyHostFormBlock7-textDarkBlue-Ysm_i`,
	"textLightBlue": `WhyHostFormBlock7-textLightBlue-b27K4`,
	"textLightSandleGreen": `WhyHostFormBlock7-textLightSandleGreen-OKgaX`,
	"textLightBrown": `WhyHostFormBlock7-textLightBrown-dEloa`,
	"textMediumMaroon": `WhyHostFormBlock7-textMediumMaroon-wvCH1`,
	"textBrown": `WhyHostFormBlock7-textBrown-mU44d`,
	"textMaroon": `WhyHostFormBlock7-textMaroon-ov8zD`,
	"textDarkBrown": `WhyHostFormBlock7-textDarkBrown-cWWN6`,
	"textMediumBrown": `WhyHostFormBlock7-textMediumBrown-YbvH3`,
	"textSkyBlue": `WhyHostFormBlock7-textSkyBlue-KdFvr`,
	"textGray": `WhyHostFormBlock7-textGray-thhvE`,
	"errorMessage": `WhyHostFormBlock7-errorMessage-Gybql`,
	"userText": `WhyHostFormBlock7-userText-RO1k4`,
	"panelHeader": `WhyHostFormBlock7-panelHeader-lHWZh`,
	"exportSection": `WhyHostFormBlock7-exportSection-CRTR_`,
	"exportSectionGridSub": `WhyHostFormBlock7-exportSectionGridSub-a59hj`,
	"exportText": `WhyHostFormBlock7-exportText-TVkIq`,
	"exportLinkImg": `WhyHostFormBlock7-exportLinkImg-nQXfE`,
	"exportImg": `WhyHostFormBlock7-exportImg-EvERP`,
	"linkBtn": `WhyHostFormBlock7-linkBtn-xGV9e`,
	"table": `WhyHostFormBlock7-table-MSBNB`,
	"tableRow": `WhyHostFormBlock7-tableRow-P5VBp`,
	"tableCell": `WhyHostFormBlock7-tableCell-0ajZO`,
	"formGroup": `WhyHostFormBlock7-formGroup-HK3LU`,
	"marginTop0": `WhyHostFormBlock7-marginTop0-nFSao`,
	"marginBottom20": `WhyHostFormBlock7-marginBottom20-pRyvD`,
	"bannerImageBg": `WhyHostFormBlock7-bannerImageBg-QW1J0`,
	"bannerDelete": `WhyHostFormBlock7-bannerDelete-NOImL`,
	"exportLink": `WhyHostFormBlock7-exportLink-Q7opX`,
	"seachContent": `WhyHostFormBlock7-seachContent-A1idG`,
	"marginBottom9": `WhyHostFormBlock7-marginBottom9-oFoVw`,
	"spaceTop52": `WhyHostFormBlock7-spaceTop52-QRhi_`,
	"profileViewInner": `WhyHostFormBlock7-profileViewInner-eaRrk`,
	"profileViewMain": `WhyHostFormBlock7-profileViewMain-SV0Lt`,
	"profileViewlabel": `WhyHostFormBlock7-profileViewlabel-JseZW`,
	"profileViewMainContent": `WhyHostFormBlock7-profileViewMainContent-wCb2A`,
	"reviewsFormStar": `WhyHostFormBlock7-reviewsFormStar-nmVx0`,
	"addLanguageText": `WhyHostFormBlock7-addLanguageText-TZSXn`
};
module.exports = ___CSS_LOADER_EXPORT___;
